import { useEffect } from "react";
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "@/site/site.css";

const pin = L.divIcon({ className: "site-pin", html: "<span></span>", iconSize: [22, 22], iconAnchor: [11, 11] });
const TR = [39.0, 35.2];

function Clicks({ onPick }) {
  useMapEvents({ click: (e) => onPick({ lat: +e.latlng.lat.toFixed(6), lng: +e.latlng.lng.toFixed(6) }) });
  return null;
}

function Follow({ lat, lng }) {
  const map = useMap();
  useEffect(() => { if (lat != null && lng != null) map.setView([lat, lng], Math.max(map.getZoom(), 15)); }, [lat, lng, map]);
  return null;
}

export function MapPicker({ lat, lng, onPick, testid = "map-picker" }) {
  const has = lat != null && lng != null;
  return (
    <div className="lst-map" data-testid={testid}>
      <MapContainer center={has ? [lat, lng] : TR} zoom={has ? 15 : 6} scrollWheelZoom style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Clicks onPick={onPick} />
        <Follow lat={lat} lng={lng} />
        {has && <Marker position={[lat, lng]} icon={pin} draggable eventHandlers={{ dragend: (e) => { const p = e.target.getLatLng(); onPick({ lat: +p.lat.toFixed(6), lng: +p.lng.toFixed(6) }); } }} />}
      </MapContainer>
    </div>
  );
}
